import { useCallback, useContext, useState } from "react";
import GlobalContext from "../../context/GlobalContext";
import DataTableComponent from "./DataTableComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { format, parseISO } from "date-fns";
import CategoryBadge from "../utilities/CategoryBadge";
import swal from "../../services/swalConfig";
import { deleteHoliday, fetchHolidays } from "../../api/HolidayApi";
import { Badge } from "react-bootstrap";

import { tr } from "../../i18n";
const TableHolidays = ({ refresh }) => {
  const { user, setLoading } = useContext(GlobalContext);
  const [reload, setReload] = useState(0);
  const navigate = useNavigate();

  const fetchData = useCallback(
    async ({ page, perPage, search }) => {
      if (!user?.workspace?.company_id) return { data: [], total: 0 }; // Hindari request jika company_id belum tersedia

      const response = await fetchHolidays({
        companyId: user.workspace.company_id,
        page,
        perPage,
        search,
      });

      const numberedData = response.data.map((item, index) => ({
        ...item,
        no: (page - 1) * perPage + index + 1,
      }));

      return { data: numberedData, total: response.total };
    },
    [user, reload, refresh] // Tambahkan dependency agar berubah saat user berubah
  );

  const handleEdit = (data) => {
    navigate(`/holiday/form?edit=${data.id}`, { state: data });
  };

  const handleDelete = async (id) => {
    const result = await swal.fire({
      title: tr("shared:are_you_sure"),
      text: tr("attendance:you_want_to_delete_this_holiday"),
      icon: "warning",
      showCancelButton: false,
      confirmButtonText: tr("shared:i_understand_delete"),
      confirmButtonColor: "#f10f29ff",
      cancelButtonText: tr("common:actions.cancel"),
      timer: false,
    });

    if (result.isConfirmed) {
      processDeleteHoliday(id);
    }
  };

  const processDeleteHoliday = async (id) => {
    try {
      setLoading(true);

      const data = {
        company_id: user.workspace.company_id,
        holiday_id: id,
      };

      const response = await deleteHoliday(data);

      if (response.status == 200) {
        swal.fire({
          title: tr("shared:success"),
          text: response.message,
          icon: "success",
          showCancelButton: false,
        });

        setReload((prev) => prev + 1);
      } else {
        swal.fire({
          title: tr("common:errors.oops"),
          text: response.message,
          icon: "error",
          showCancelButton: false,
        });
      }
    } catch (error) {
      swal.fire({
        title: tr("common:errors.oops"),
        text: tr("common:errors.generic"),
        icon: "error",
        showCancelButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { name: tr("shared:no"), selector: (row) => row.no, width: "70px", sortable: true },
    {
      name: tr("attendance:event"),
      selector: (row) => row.event,
      sortable: true,
      wrap: true,
    },
    {
      name: tr("shared:from"),
      selector: (row) => format(parseISO(row.date_from), "dd MMM yyyy"),
      sortable: true,
    },
    {
      name: tr("shared:to"),
      selector: (row) => format(parseISO(row.date_to), "dd MMM yyyy"),
      sortable: true,
    },
    {
      name: tr("attendance:reduce_paid_leave"),
      selector: (row) => row.reduce_paid_leave,
      sortable: true,
      center: true,
      cell: (row) => (
        <Badge bg={row.reduce_paid_leave ? "danger" : "success"}>
          {row.reduce_paid_leave ? tr("common:actions.yes") : tr("shared:no")}
        </Badge>
      ),
    },
    {
      name: tr("shared:actions"),
      center: true,
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={() => handleEdit(row)}
            className="btn btn-primary btn-sm"
          >
            <FontAwesomeIcon icon={faEdit} className="me-1" /> {" "}{tr("common:breadcrumb.edit")}
          </button>
          <button
            onClick={() => handleDelete(row.id)}
            className="btn btn-danger btn-sm"
          >
            <FontAwesomeIcon icon={faTrash} className="me-1" /> {" "}{tr("common:actions.delete")}
          </button>
        </div>
      ),
      width: "25%",
      style: {
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      },
    },
  ];

  return (
    <div>
      <DataTableComponent columns={columns} fetchData={fetchData} />
    </div>
  );
};

export default TableHolidays;
